(function () {
  var container = document.getElementById('ssgGlobeViz');
  if (!container) return;

  container.innerHTML = '<div class="ssg-loading">Loading globe…</div>';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Single source of truth: read the campaigns from the JSON the page prints
  // (so the globe markers and the info cards below can never drift apart).
  // Falls back to this inline list if the JSON tag is missing.
  var campaigns;
  try {
    var dataTag = document.getElementById('ssgCampaigns');
    campaigns = dataTag ? JSON.parse(dataTag.textContent) : null;
  } catch (e) { campaigns = null; }
  if (!campaigns || !campaigns.length) {
    campaigns = [
      { lat: -75, lng: -40, eyebrow: 'Southern Ocean', title: 'Operation Antarctica Defense', detail: 'Patrols the Southern Ocean to document and oppose industrial krill fishing in critical whale feeding grounds.' },
      { lat: -33.5, lng: 132, eyebrow: 'Great Australian Bight', title: 'Operation Jeedara', detail: "A multi-year campaign that helped stop offshore oil drilling in one of Australia's most ecologically significant marine areas." },
      { lat: -8, lng: 178, eyebrow: 'South Pacific', title: 'Operation Tuvalu', detail: 'Supports reef and atoll defense for Pacific island nations facing rising seas and marine habitat loss.' },
      { lat: 6.4, lng: -10.8, eyebrow: 'West Africa', title: 'Illegal Fishing Campaign', detail: 'Partners with national coast guards, including Liberia, to intercept vessels engaged in illegal, unreported fishing.' },
      { lat: 37.1, lng: 15.3, eyebrow: 'Sicily, Italy', title: 'Operation Siso', detail: "Targets illegal fishing and poaching inside the Plemmirio Marine Reserve on Sicily's east coast." },
      { lat: 62, lng: -7, eyebrow: 'Faroe Islands', title: 'Operation Living Fjords', detail: 'Opposes the pilot whale and dolphin hunts known as the Grind, through direct presence and public pressure.' },
      { lat: 58, lng: 19, eyebrow: 'Baltic Sea', title: 'Baltic Sea Campaign', detail: 'Works to protect harbor porpoises, one of the most endangered marine mammal populations in Europe.' }
    ];
  }
  campaigns.forEach(function (c, i) { c.__i = i; if (c.alt == null) c.alt = 0.02; });

  function solarSubsolarPoint(date) {
    var ms = date.getTime();
    var dayMs = 86400000;
    var J2000 = new Date('2000-01-01T12:00:00Z').getTime();
    var daysSinceJ2000 = (ms - J2000) / dayMs;
    var rad = Math.PI / 180;
    var L = (280.460 + 0.9856474 * daysSinceJ2000) % 360;
    var g = (357.528 + 0.9856003 * daysSinceJ2000) % 360;
    var lambda = L + 1.915 * Math.sin(g * rad) + 0.020 * Math.sin(2 * g * rad);
    var epsilon = 23.439 - 0.0000004 * daysSinceJ2000;
    var decl = Math.asin(Math.sin(epsilon * rad) * Math.sin(lambda * rad)) / rad;
    var y = Math.tan(epsilon / 2 * rad) * Math.tan(epsilon / 2 * rad);
    var eqTime = 4 / rad * (
      y * Math.sin(2 * L * rad)
      - 2 * 0.0167 * Math.sin(g * rad)
      + 4 * 0.0167 * y * Math.sin(g * rad) * Math.cos(2 * L * rad)
      - 0.5 * y * y * Math.sin(4 * L * rad)
      - 1.25 * 0.0167 * 0.0167 * Math.sin(2 * g * rad)
    );
    var utcHours = date.getUTCHours() + date.getUTCMinutes() / 60 + date.getUTCSeconds() / 3600;
    var solarTime = utcHours + eqTime / 60;
    var lng = 180 - solarTime * 15;
    while (lng > 180) lng -= 360;
    while (lng < -180) lng += 360;
    return { lat: decl, lng: lng };
  }

  // Build the info cards under the globe from the same campaign data.
  function renderCards(activeCb) {
    var grid = document.getElementById('ocLocGrid');
    if (!grid) return;
    grid.innerHTML = '';
    campaigns.forEach(function (c) {
      var card = document.createElement('div');
      card.className = 'oc-loc-card';
      card.id = 'ocLoc-' + c.__i;
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      var srcLink = c.url
        ? '<a class="oc-loc-src" href="' + c.url + '" target="_blank" rel="noopener">Read the campaign <span aria-hidden="true">↗</span></a>'
        : '';
      card.innerHTML =
        '<span class="oc-loc-dot" aria-hidden="true"></span>' +
        '<span class="oc-loc-region">' + c.eyebrow + '</span>' +
        '<span class="oc-loc-title">' + c.title + '</span>' +
        '<span class="oc-loc-detail">' + c.detail + '</span>' +
        srcLink;
      // clicking the card focuses the globe; the source link opens normally
      card.addEventListener('click', function (e) {
        if (e.target.closest('.oc-loc-src')) return; // let the real link through
        activeCb(c, true);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activeCb(c, true); }
      });
      grid.appendChild(card);
    });
  }

  function initGlobe() {
    if (typeof Globe === 'undefined' || typeof THREE === 'undefined') {
      container.innerHTML = '<div class="ssg-loading">Globe failed to load. Check your connection.</div>';
      return;
    }
    container.innerHTML = '';

    var eyebrowEl = document.getElementById('ssgCardEyebrow');
    var titleEl = document.getElementById('ssgCardTitle');
    var detailEl = document.getElementById('ssgCardDetail');
    var srcEl = document.getElementById('ssgCardSrc');
    var card = document.getElementById('ssgCard');

    var isTouchDevice = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
    var touchRadius = isTouchDevice ? 2.2 : 0.55;
    var pointAlt = isTouchDevice ? 0.06 : 0.04;

    // Highlight helper shared by globe clicks and card clicks.
    function focusCampaign(point, fromCard) {
      if (card) {
        card.style.opacity = '0.3';
        setTimeout(function () {
          eyebrowEl.textContent = point.eyebrow;
          titleEl.textContent = point.title;
          detailEl.textContent = point.detail;
          // the campaign's real Sea Shepherd page — this panel is now the only place it appears
          if (srcEl) {
            if (point.url) { srcEl.href = point.url; srcEl.hidden = false; }
            else { srcEl.removeAttribute('href'); srcEl.hidden = true; }
          }
          card.style.opacity = '1';
        }, 120);
      }
      // spin the globe to the selected point
      if (window.__ssgGlobe) {
        window.__ssgGlobe.pointOfView({ lat: point.lat, lng: point.lng, altitude: isTouchDevice ? 1.9 : 1.5 }, 900);
      }
      // mark the matching card active
      document.querySelectorAll('.oc-loc-card').forEach(function (el) { el.classList.remove('is-active'); });
      var target = document.getElementById('ocLoc-' + point.__i);
      if (target) {
        target.classList.add('is-active');
        // if the click came FROM the globe, bring the card into view
        if (!fromCard) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    var myGlobe = Globe()
      .globeImageUrl('https://cdn.jsdelivr.net/npm/three-globe/example/img/earth-blue-marble.jpg')
      .bumpImageUrl('https://cdn.jsdelivr.net/npm/three-globe/example/img/earth-topology.png')
      .backgroundColor('rgba(0,0,0,0)')
      .showAtmosphere(true)
      .atmosphereColor('#8fd3ec')
      .atmosphereAltitude(0.22)
      .pointsData(campaigns)
      .pointLat('lat')
      .pointLng('lng')
      .pointAltitude(pointAlt)
      .pointColor(function () { return '#ff5a3c'; })
      .pointRadius(touchRadius)
      .pointResolution(12)
      .pointLabel(function (d) { return d.title; })
      .ringsData(campaigns)
      .ringLat('lat')
      .ringLng('lng')
      .ringColor(function () { return function (t) { return 'rgba(255,90,60,' + Math.sqrt(1 - t) * 0.55 + ')'; }; })
      .ringMaxRadius(isTouchDevice ? 6.5 : 3.2)
      .ringPropagationSpeed(2)
      .ringRepeatPeriod(2200)
      .onPointClick(function (point) { focusCampaign(point, false); })
      (container);

    window.__ssgGlobe = myGlobe;

    // ---- INTRO: big zoom-IN on load, then a slow cinematic zoom-OUT ----
    // The zoom-out fires once the earth texture has loaded (see dayTex below), so the
    // dramatic close-up always shows the planet, never a blank frame. A fallback timer
    // guarantees the reveal even if the texture is slow.
    var revealAlt = isTouchDevice ? 2.6 : 2.2;
    var revealed = false;
    function revealIntro() {
      if (revealed) return; revealed = true;
      myGlobe.pointOfView({ lat: 14, lng: 20, altitude: revealAlt }, 4000); // slow zoom-out to the full globe
    }
    if (RM) {
      myGlobe.pointOfView({ lat: 12, lng: 40, altitude: revealAlt }, 0); // reduced motion: no zoom
      revealed = true;
    } else {
      myGlobe.pointOfView({ lat: 6, lng: 35, altitude: 0.35 }, 0); // big zoom-IN, right up on the planet
      setTimeout(revealIntro, 2800); // fallback so it always zooms back out
    }

    // gentle idle auto-rotate once the reveal is underway
    myGlobe.controls().autoRotate = !RM;
    myGlobe.controls().autoRotateSpeed = 0.35;

    // --- Real day/night shading based on current sun position ---
    var loader = new THREE.TextureLoader();
    var dayTex = loader.load('https://cdn.jsdelivr.net/npm/three-globe/example/img/earth-blue-marble.jpg', function () { setTimeout(revealIntro, 400); });
    var nightTex = loader.load('https://cdn.jsdelivr.net/npm/three-globe/example/img/earth-night.jpg');
    var sun = solarSubsolarPoint(new Date());
    var sunRad = Math.PI / 180;
    var sunDir = new THREE.Vector3(
      Math.cos(sun.lat * sunRad) * Math.cos(sun.lng * sunRad),
      Math.sin(sun.lat * sunRad),
      -Math.cos(sun.lat * sunRad) * Math.sin(sun.lng * sunRad)
    );
    var dayNightMaterial = new THREE.ShaderMaterial({
      uniforms: { dayTexture: { value: dayTex }, nightTexture: { value: nightTex }, sunDirection: { value: sunDir } },
      vertexShader: [
        'varying vec2 vUv;', 'varying vec3 vNormalW;',
        'void main() {', '  vUv = uv;', '  vNormalW = normalize(mat3(modelMatrix) * normal);',
        '  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);', '}'
      ].join('\n'),
      fragmentShader: [
        'uniform sampler2D dayTexture;', 'uniform sampler2D nightTexture;', 'uniform vec3 sunDirection;',
        'varying vec2 vUv;', 'varying vec3 vNormalW;',
        'void main() {',
        '  float intensity = dot(normalize(vNormalW), normalize(sunDirection));',
        '  float mixAmount = smoothstep(-0.25, 0.25, intensity);',
        '  vec3 dayColor = texture2D(dayTexture, vUv).rgb * 1.22;',
        '  vec3 nightColor = texture2D(nightTexture, vUv).rgb * 1.7 + 0.05;',
        '  vec3 color = mix(nightColor, dayColor, mixAmount);',
        '  gl_FragColor = vec4(color, 1.0);', '}'
      ].join('\n')
    });
    myGlobe.globeMaterial(dayNightMaterial);

    // --- Scroll-trap fix: wheel/pinch zoom stays OFF until the user engages ---
    myGlobe.controls().enableZoom = false;
    myGlobe.controls().minDistance = 140;
    myGlobe.controls().maxDistance = 480;
    myGlobe.controls().zoomSpeed = 0.35;
    myGlobe.controls().enableDamping = true;
    myGlobe.controls().dampingFactor = 0.12;

    var engageHint = document.createElement('div');
    engageHint.className = 'ssg-engage-hint';
    engageHint.textContent = isTouchDevice ? 'Tap and hold to zoom' : 'Click the globe to enable zoom';
    container.appendChild(engageHint);
    var zoomEngaged = false;
    function engageZoom() {
      if (zoomEngaged) return;
      zoomEngaged = true;
      myGlobe.controls().autoRotate = false;
      myGlobe.controls().enableZoom = true;
      engageHint.classList.add('ssg-engage-hint--hidden');
    }
    container.addEventListener('mousedown', engageZoom, { once: true });
    container.addEventListener('touchstart', engageZoom, { once: true, passive: true });

    // --- Cloud layer ---
    var CLOUDS_ALT = 0.006;
    var CLOUDS_ROTATION_SPEED = -0.018;
    var cloudGeometry = new THREE.SphereGeometry(myGlobe.getGlobeRadius() * (1 + CLOUDS_ALT), 75, 75);
    var clouds = new THREE.Mesh(cloudGeometry);
    loader.load('https://cdn.jsdelivr.net/npm/three-globe/example/clouds/clouds.png', function (t) {
      clouds.material = new THREE.MeshPhongMaterial({ map: t, transparent: true, opacity: 0.45 });
    }, undefined, function () {});
    myGlobe.scene().add(clouds);
    (function rotateClouds() { clouds.rotation.y += (CLOUDS_ROTATION_SPEED * Math.PI) / 180; requestAnimationFrame(rotateClouds); })();

    // Robust sizing: if the stylesheet hasn't applied the container height yet,
    // fall back to a viewport-based height so the globe never renders into a 0px box.
    function sizeGlobe() {
      var w = container.clientWidth || window.innerWidth;
      var h = container.clientHeight;
      if (h < 80) h = Math.round(window.innerHeight * 0.72);
      myGlobe.width(w).height(h);
    }
    sizeGlobe();
    window.addEventListener('resize', sizeGlobe);
    if (window.ResizeObserver) { try { new ResizeObserver(sizeGlobe).observe(container); } catch (e) {} }
    setTimeout(sizeGlobe, 400);
    setTimeout(sizeGlobe, 1600);

    // build the info cards under the globe and wire them to the globe
    renderCards(focusCampaign);
  }

  var checkInterval = setInterval(function () {
    if (typeof Globe !== 'undefined' && typeof THREE !== 'undefined') { clearInterval(checkInterval); initGlobe(); }
  }, 100);
  setTimeout(function () {
    clearInterval(checkInterval);
    if (typeof Globe === 'undefined') { container.innerHTML = '<div class="ssg-loading">Globe failed to load. Check your connection.</div>'; }
  }, 8000);
})();
